import React, { useState, useEffect } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import classNames from "classnames";

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const m = window.matchMedia(query);
    setMatches(m.matches);
    const listener = (e) => setMatches(e.matches);
    m.addEventListener("change", listener);
    return () => m.removeEventListener("change", listener);
  }, [query]);
  return matches;
};

const HeaderMenu = ({ onMouseEnter = () => {}, onMouseLeave = () => {} }) => {
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const [openSubmenuId, setOpenSubmenuId] = useState(null);

  const { links } = useStaticQuery(graphql`
    query MenuHeader {
      links: allWpMenuItem(
        filter: { locations: { eq: HEADER_MENU }, parentId: { eq: null } }
      ) {
        edges {
          node {
            id
            label
            uri
            childItems {
              nodes {
                id
                label
                uri
              }
            }
          }
        }
      }
    }
  `);

  const mouseEnter = ({ currentTarget }) => {
    const anchor = currentTarget.querySelector(":scope > a");
    if (!anchor) return;
    const left = currentTarget.offsetLeft + anchor.offsetLeft;
    const width = anchor.offsetWidth;
    onMouseEnter(left, width);
  };

  return (
    <div className="menu-header-menu-container">
      <ul>
        {links.edges.map(({ node }) => {
          const hasChildren =
            node.childItems?.nodes && node.childItems.nodes.length > 0;
          const isOpen = openSubmenuId === node.id;

          return (
            <li
              className={classNames("menu-item", {
                "menu-item-has-children": hasChildren,
              })}
              key={node.id}
              onMouseEnter={mouseEnter}
              onMouseLeave={onMouseLeave}
            >
              <Link activeClassName="menu-item-active" to={node.uri}>
                {node.label}
              </Link>
              {hasChildren && isMobile && (
                <span
                  className={classNames("thereCaret", { active: isOpen })}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOpenSubmenuId((prev) => (prev === node.id ? null : node.id));
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setOpenSubmenuId((prev) => (prev === node.id ? null : node.id));
                    }
                  }}
                  role="button"
                  tabIndex={0}
                  aria-expanded={isOpen}
                  aria-label={isOpen ? "Close submenu" : "Open submenu"}
                >
                  <span className="thereCaret-icon" aria-hidden>
                    {isOpen ? "−" : "+"}
                  </span>
                </span>
              )}
              {hasChildren && (
                <ul className={classNames("sub-menu", { openMenu: isOpen })}>
                  {node.childItems.nodes.map((child) => (
                    <li key={child.id}>
                      <Link to={child.uri}>{child.label}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default HeaderMenu;
